import React from "react";
import Modal from "react-bootstrap/Modal";
import Confirm from "../../assets/svg/Tick.gif";
import Lottie from "lottie-react";
import ConfirmTick from "../../assets/lottie/Tick.gif.json";
import "./Modal.css";

const CommonModal = (props) => {
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="modal-main-wrapper">
            <div className="modal-lotte-wrap">
              <Lottie animationData={ConfirmTick} loop={true} />
            </div>
            <h3>{props.type}</h3>

            <div className="modal-side-image-wrap">
              <img src="./images/modal-side-img.png" alt="img" />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CommonModal;
